@if (!autoSignInInProgress) {
  <div id="login-container">

    <button class="login-button bullhorn" (click)="signInWithBullhorn()" [disabled]="signinInProgress()" autofocus>
      Sign in with Bullhorn
      @if (bullhornSigninInProgress()) {
        <span class="loading-spinner spinner-border spinner-border-sm"></span>
      }
    </button>

    <div class="salesforce-login">
      <button class="login-button salesforce" (click)="signInWithSalesforce()" [disabled]="signinInProgress()"
              autofocus>
        Sign in with Salesforce
        @if (salesForceSigninInProgress()) {
          <span class="loading-spinner spinner-border spinner-border-sm"></span>
        }
      </button>
      <mat-slide-toggle class="sandbox-toggle" [(ngModel)]="useSalesforceSandbox">Sandbox</mat-slide-toggle>
    </div>

    <form (ngSubmit)="signInWithInvenias(tenantName.value)">
      <button class="login-button invenias" [disabled]="signinInProgress()">
        Sign in with Invenias
        @if (inveniasSigninInProgress()) {
          <span class="loading-spinner spinner-border spinner-border-sm"></span>
        }
        <div class="tenant-container">
          <span>Tenant</span>
          <span id="tenant-login">
            <input
              type="text"
              name="tenant"
              placeholder="e.g. Kyloe"
              value="{{ lastUsedTenant }}"
              #tenantName
              (click)="$event.preventDefault()"
            />
            <!-- prevents the button click -->
            @if (tenantName.value) {
              <i
                class="bhi-times clear-icon"
                [matTooltip]="'Clear text'"
                matTooltipShowDelay="500"
                tabindex="0"
                (click)="clearInput(tenantName, $event)"
                (keydown.space)="clearInput(tenantName)"
                (keydown.enter)="clearInput(tenantName)"
              ></i>
            }
          </span>
        </div>
      </button>
    </form>
  </div>
}
